import Vue from 'vue'
import App from './App.vue'
//import Axios from "axios";
import vuetify from './plugins/vuetify'


//Axios.defaults.baseURL = "http://localhost:8080/";
export const bus = new Vue();

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')

